import React from 'react'
import PropTypes from 'prop-types'
import { Dimmer, Loader as SemanticLoader } from 'semantic-ui-react'

import styled from 'styled-components'

import './styles.css'

const Container = styled.div`
  position: relative;
  min-height: 200px;
`

/**
 * @param {object} props
 * @param {string} [props.className]
 * @param {import('react').CSSProperties} [props.style]
 * @param {boolean} [props.withContainer]
 * @param {string|number} [props.containerHeight]
 * @param {import('react').CSSProperties} [props.containerStyle]
 */
export const Loader = ({ className, style, withContainer, containerHeight, containerStyle }) => {
  const loader = (
    <Dimmer
      active
      inverted
      className={['ss-loader-dimmer', className].filter(Boolean).join(' ')}
      style={style}
    >
      <SemanticLoader inverted />
    </Dimmer>
  )

  return withContainer ? (
    <Container style={{ minHeight: containerHeight, ...containerStyle }}>{loader}</Container>
  ) : (
    loader
  )
}

Loader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  withContainer: PropTypes.bool,
  containerStyle: PropTypes.object,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/shared/components/Loader/index.js